function addGiftCart({ item, cartItems, conditionProductId, giftVariantId }) {
  const items = Array.isArray(item?.items) ? item.items : Array.isArray(item)? item : [item];

  const hasConditionProduct = items.some((lineItem) => {
    return String(lineItem?.product_id) === String(conditionProductId);
  });

  if (!hasConditionProduct) return;

  const giftAlreadyInCart = cartItems.some((cartItem) => {
    return String(cartItem.id ?? cartItem.product_id) === String(giftVariantId);
  });
  if (giftAlreadyInCart) return;

  const Cart = window.Rebuy.Cart;
  if (!Cart || !giftVariantId) return;

  Cart.addItem({
    id: giftVariantId,
    quantity: 1
  });
}

function showNotification(smartcart, item) {
  const notification = document.querySelector('[data-gift-cart-notification]');
  const buttons = notification.querySelectorAll('[data-gift-cart-button]');
  if (window.cart_gift.product_gift == item.id || window.cart_gift.product_gift_2 == item.id) {
    notification.classList.add('is-visible');
  }

  notification.querySelectorAll('[data-gift-cart-button]').forEach((button) =>
    button.addEventListener('click', (event) => {
      event.preventDefault();

      const eventButton = event.currentTarget.dataset.giftCartButton;
      const Cart = window.Rebuy.Cart;
      if (eventButton == 'second') {
        if (window.cart_gift.product_gift == item.id) {
          Cart.addItem({
            id: window.cart_gift.product_gift,
            quantity: 1
          });
        } else if(window.cart_gift.product_gift_2 == item.id) {
          Cart.addItem({
            id: window.cart_gift.product_gift_2,
            quantity: 1
          });
        }
      } else {
        sessionStorage.setItem('gift-cart', 'unadd');
      }
      notification.classList.remove('is-visible');
    })
  );
}

function onAddGiftCart() {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  
  let formData = {
   'items': [{
      'id': window.cart_gift.product_gift,
      'quantity': 1
    }]
  };

  config.body = JSON.stringify({
    ...formData,
    sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      let error = true;
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'gift-cart',
          productVariantId: formData['items'][0]['id'],
          errors: response.errors || response.description,
          message: response.message,
        });
        error = true;
        return;
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gift-cart',
          productVariantId: formData['items'][0]['id'],
          cartData: response,
        });
      error = false;
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    });
}
